import {useContext} from 'react'

import PropTypes from 'prop-types'

import {atomIconRenders, atomIconSizes} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import IconAutomaticTransmission from '@adv-mt/mt-svg-icons/lib/AutomaticTransmission'
import IconFuelDiesel from '@adv-mt/mt-svg-icons/lib/FuelDiesel'
import IconFuelElectricHybrid from '@adv-mt/mt-svg-icons/lib/FuelElectricHybrid'
import IconFuelGasoline from '@adv-mt/mt-svg-icons/lib/FuelGasoline'
import IconFuelStation from '@adv-mt/mt-svg-icons/lib/FuelStation'
import IconManualTransmission from '@adv-mt/mt-svg-icons/lib/ManualTransmission'
import TagChip, {tagChipSizes, tagChipTypes} from '@adv-mt/mt-tag-chip'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS_NAME} from '../../config.js'

const CardVehicleSeller = ({vehicleData}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {
    FUEL_TYPE_DIESEL_ID,
    FUEL_TYPE_ELECTRIC_ID,
    FUEL_TYPE_GASOLINE_ID,
    TRANNSMISSION_TYPE_ID_AUTOMATIC,
    TRANNSMISSION_TYPE_ID_MANUAL
  } = config.get('search')

  const {
    bodyType,
    doors,
    fuelType,
    fuelTypeId,
    imageUrlPath,
    make,
    model,
    plate,
    plateRegistrationYear,
    transmissionType,
    transmissionTypeId,
    version
  } = vehicleData

  function getTypeIconFuel(fuelId) {
    const fuelTypesIconList = {
      [FUEL_TYPE_DIESEL_ID]: IconFuelDiesel,
      [FUEL_TYPE_GASOLINE_ID]: IconFuelGasoline,
      [FUEL_TYPE_ELECTRIC_ID]: IconFuelElectricHybrid
    }
    return fuelTypesIconList[fuelId] || IconFuelStation
  }

  function getTypeIconTransmission(transmissionId) {
    const transmissionTypesIconList = {
      [TRANNSMISSION_TYPE_ID_AUTOMATIC]: IconAutomaticTransmission,
      [TRANNSMISSION_TYPE_ID_MANUAL]: IconManualTransmission
    }
    return transmissionTypesIconList[transmissionId] || IconManualTransmission
  }
  const title = `${make} ${model || ''} ${version || ''}`
  const vehicleSpecs = []

  if (bodyType && doors)
    vehicleSpecs.push({
      label: i18n.t('COMMON.PLURALS.BODY_TYPE', 1),
      value: i18n.t('TECHNICAL_DETAILS_BODY_TYPE_DOORS_TAG', {bodyType, doors})
    })

  if (fuelType && fuelTypeId)
    vehicleSpecs.push({
      label: i18n.t('COMMON.FUEL'),
      value: fuelType,
      Icon: getTypeIconFuel(fuelTypeId)
    })

  if (transmissionType && transmissionTypeId)
    vehicleSpecs.push({
      label: i18n.t('COMMON.TRANSMISSION'),
      value: transmissionType,
      Icon: getTypeIconTransmission(transmissionTypeId)
    })

  if (plateRegistrationYear)
    vehicleSpecs.push({
      label: i18n.t('LANDING_VEHICLE_APPRAISER.FORM.YEAR.LABEL'),
      value: plateRegistrationYear
    })

  return (
    <div className={`${BASE_CLASS_NAME}-card`}>
      <div className={`${BASE_CLASS_NAME}-cardImageWrapper`}>
        <AtomImage className={`${BASE_CLASS_NAME}-cardImage`} src={imageUrlPath} alt={''} />
      </div>
      <div className={`${BASE_CLASS_NAME}-cardSeparator`} />
      <div className={`${BASE_CLASS_NAME}-cardTitle`}>
        <TitleBasic
          as={titleBasicTags.h2}
          color={titleBasicColors.currentColor}
          size={titleBasicSizes.xs}
          title={title}
        />
        {plate ? (
          <div>
            <TagChip isFitted label={plate} size={tagChipSizes.SMALL} type={tagChipTypes.PRIMARY_WITHOUT_HOVER} />
          </div>
        ) : null}
      </div>
      <div className={`${BASE_CLASS_NAME}-cardSpecs`}>
        <ul className={`${BASE_CLASS_NAME}-cardSpecsList`}>
          {vehicleSpecs.map(({label, value, Icon}, index) => (
            <li key={index} className={`${BASE_CLASS_NAME}-cardSpecsItem`}>
              <span className={`${BASE_CLASS_NAME}-cardSpecsItemLabel`}>{`${label}:`}</span>
              {Icon ? (
                <span className={`${BASE_CLASS_NAME}-cardSpecsItemIcon`}>
                  <Icon render={atomIconRenders.lazy} size={atomIconSizes.extraSmall} />
                </span>
              ) : null}
              {value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

CardVehicleSeller.displayName = 'CardVehicleSeller'

CardVehicleSeller.propTypes = {
  vehicleData: PropTypes.object.isRequired
}

export default CardVehicleSeller
